import React from 'react';

const OccurrenceContext = React.createContext();

export const useOccurrence = () => React.useContext(OccurrenceContext);

export default OccurrenceContext;
